import axios from '../axios'

/*
 * 數據模塊
 */
//
// export const getImageList = (data) => {
//   return axios({
//     url: '/dataApi/service/fileRes/load',
//     method: 'post',
//     params: data
//   })
// };

export const getImageList = (data) => {
  return axios({
    url: '/api/fileRes/load',
    method: 'post',
    params: data
  })
};

export const uploadCloud = (data) => {
  return axios({
    url: '/api/service/Cloud/apply',
    method: 'get',
    params: data
  })
};


export const findConsult = (data) => {
  return axios({
    url: '/api/service/Cloud/findConsult',
    method: 'get',
    params: data
  })
};

// export const searchLocalDept = () => {
//   return axios({
//     url: '/dataApi/baseDept/localDept',
//     method: 'get',
//     // params: data
//   })
// };

export const findTemplateReport = (data) => {
  return axios({
  url: '/api/template/find_template_report',
  method: 'post',
  data:data
  })
};

/*
 * 查询个人模板
 */
export const findTemplateReportSelf = (data) => {
  return axios({
  url: '/api/template/find_template_report_self',
  method: 'post',
  data:data
  })
};



//增加或修改个人模板
export const addOrUpdateTemplateSelf = (data) => {
	return axios({
		url: '/api/template/add_or_update_template_report_self',
		method: 'post',
		data: data
	})
};


// 删除个人模板
export const deleteTemplateSelf = (id) => {
	return axios({
		url: '/api/template/delete_template_report_self?id=' + id,
		method: 'post'
	})
};


// 查询个人模板设备类型
export const findTemplateReportDeviceType = (data) => {
	return axios({
		url: '/api/template/find_template_report_device_type',
		method: 'GET',
		params:data
	})
};


// 查询个人模板疾病分类
export const findTemplateReportDiseaseType = (data) => {
	return axios({
		url: '/api/template/find_template_report_disease_type',
		method: 'GET',
		params:data
	})
};

/**
 * 
 * 删除图像
 */
export const deleteImage = (data) => {
  return axios({
  url: '/api/fileRes/delete',
  method: 'get',
  params:data
  })
};

  //分页典型病例
  export const findTypicalCase = (data) => {
    return axios({
      url: '/api/typicalCase/findAll',
      method: 'get',
      params: data
    })
  };

  //分页典型病例
  export const findIdTypicalCase = (data) => {
    return axios({
      url: '/api/typicalCase/find',
      method: 'get',
      params: data
    })
  };

  // 新增留言
export const addAttention = (data) => {
	return axios({
		url: '/api/attention/add',
		method: 'post',
		data:data
	})
};

  //查找留言
  export const findAttention = (data) => {
    return axios({
      url: '/api/attention/find',
      method: 'get',
      params: data
    })
  };

  // 分页查找电子报告单
export const findAllQrReport = (data) => {
	return axios({
		url: '/api/qr_report/findAll',
		method: 'get',
		params: data
	})
};

// 查找电子报告单详情
export const findQrReport = (data) => {
	return axios({
		url: '/api/qr_report/find',
		method: 'get',
		params: data
	})
};

//调用二维码

export const findByReportId = (data) => {
	return axios({
	url: '/api/qr_report/findByReportId',
	method: 'get',
	params: data
	})
};

  // 获取徽标数
  export const hasNew = (data) => {
    return axios({
      url: '/api/report/hasNew',
      method: 'get',
      params: data
    })
  };


// WEBPACK FOOTER //
// ./src/http/moudules/data.js